// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoxPlotFilledSvg from "@fishx/icons-svg/es/asn/BoxPlotFilled";
import FishxIcon from '../components/FishxIcon';

var BoxPlotFilled = function BoxPlotFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotFilledSvg
  }));
};

BoxPlotFilled.displayName = 'BoxPlotFilled';
export default React.forwardRef(BoxPlotFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BoxPlotFilled.js
// module id = 2107
// module chunks = 0